/*
 * Adds help-centre articles (help_article metaobjects) to the main storefront
 * search. Nothing is fetched until the visitor engages search: the compact
 * index is then loaded once per session via the Section Rendering API
 * (sections/help-search-index.liquid) and matched client-side with the same
 * matcher the help centre uses (help-center.js).
 */
(function () {
  var CACHE_KEY = 'tw-help-index-v1';
  var GROUP_ATTR = 'data-help-search-group';
  var indexPromise = null;

  function rootUrl() {
    return (window.theme && theme.routes && theme.routes.root_url) || '/';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;

    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        indexPromise = Promise.resolve(prepare(JSON.parse(cached)));
        return indexPromise;
      }
    } catch (e) { /* storage unavailable */ }

    var url = rootUrl() + (rootUrl().indexOf('?') === -1 ? '?' : '&') + 'section_id=help-search-index';
    indexPromise = fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var script = doc.getElementById('help-kb-index');
        var articles = script ? JSON.parse(script.textContent) : [];
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(articles)); } catch (e) { /* ignore */ }
        return prepare(articles);
      })
      .catch(function () {
        indexPromise = null;
        return [];
      });
    return indexPromise;
  }

  function prepare(articles) {
    articles.forEach(function (a) {
      if (a._hay) return;
      a._title = (a.t || '').toLowerCase();
      a._hay = (a._title + ' ' + (a.c || '') + ' ' + (a.k || []).join(' ')).toLowerCase();
    });
    return articles;
  }

  /* Same matching as the help centre: every term present, title hits rank first */
  function match(articles, query, limit) {
    var q = query.trim().toLowerCase();
    if (!q) return { terms: [], matches: [] };
    var terms = q.split(/\s+/).filter(Boolean);
    var matches = articles.filter(function (a) {
      return terms.every(function (t) { return a._hay.indexOf(t) !== -1; });
    }).sort(function (x, y) {
      var sx = terms.filter(function (t) { return x._title.indexOf(t) !== -1; }).length;
      var sy = terms.filter(function (t) { return y._title.indexOf(t) !== -1; }).length;
      return sy - sx;
    }).slice(0, limit);
    return { terms: terms, matches: matches };
  }

  function highlight(text, terms) {
    var out = esc(text);
    terms.forEach(function (t) {
      out = out.replace(new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>');
    });
    return out;
  }

  function groupHtml(result, heading) {
    return '<p class="search__heading block text-xs uppercase leading-tight tracking-widest">' + esc(heading) + '</p>' +
      '<ul class="grid gap-2">' +
      result.matches.map(function (a) {
        return '<li>' +
          '<a class="reversed-link text-base md:text-lg leading-tight font-medium" href="' + esc(a.u) + '">' +
            highlight(a.t, result.terms) +
          '</a>' +
        '</li>';
      }).join('') +
      '</ul>';
  }

  /* ---- Predictive dropdown (drawer + search page form) ---- */

  function updateDropdown(form, container, articles) {
    var input = form.querySelector('input[type="search"]');
    var query = input ? input.value.trim() : '';
    var existing = container.querySelector('[' + GROUP_ATTR + ']');
    var result = match(articles, query, 4);

    if (!query || !result.matches.length) {
      if (existing) existing.remove();
      return;
    }
    if (existing && existing.getAttribute(GROUP_ATTR) === query) return;
    if (existing) existing.remove();

    var group = document.createElement('div');
    group.className = 'grid gap-3 md:gap-4 w-full';
    group.setAttribute(GROUP_ATTR, query);
    group.innerHTML = groupHtml(result, 'Help & guides');

    var sticky = container.querySelector('.drawer__sticky');
    sticky ? container.insertBefore(group, sticky) : container.appendChild(group);

    var empty = container.querySelector('.search__empty');
    if (empty) empty.hidden = true;
  }

  function wireDropdown(form) {
    var sectionId = form.getAttribute('data-section-id');
    var container = document.getElementById('PredictiveSearchResults-' + sectionId);
    var input = form.querySelector('input[type="search"]');
    if (!container || !input) return;

    input.addEventListener('focus', loadIndex, { once: true });

    var observer = new MutationObserver(function () {
      loadIndex().then(function (articles) {
        updateDropdown(form, container, articles);
      });
    });
    observer.observe(container, { childList: true });
  }

  /* ---- /search results page ---- */

  function wireResultsPage(container) {
    var terms = (container.getAttribute('data-terms') || '').trim();
    if (!terms) return;

    loadIndex().then(function (articles) {
      var result = match(articles, terms, 8);
      if (!result.matches.length) return;

      var helpUrl = container.getAttribute('data-help-url');
      var viewAll = helpUrl
        ? '<p><a class="link text-base md:text-lg" href="' + esc(helpUrl) + '">View all help articles</a></p>'
        : '';
      container.innerHTML = '<div class="grid gap-3 md:gap-4 w-full">' + groupHtml(result, 'Help & guides') + viewAll + '</div>';
      container.hidden = false;
    });
  }

  function init() {
    document.querySelectorAll('form[is="predictive-search"]').forEach(wireDropdown);

    var results = document.getElementById('HelpSearchResults');
    if (results) wireResultsPage(results);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
